import comp from "./ResponseItemV2";
export default comp;
